import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form-v7';
import { EyeOff, Eye } from '@parrot-software/design-system/icons';

import { RadioCardGrid, StepLayout } from '@onboarding/presentation/components/shared';
import { CASH_REGISTER_TYPES } from '@onboarding/domain/value-objects';
import type { WizardFormValues } from '@onboarding/presentation/types';

/**
 * Step 4 of the onboarding wizard: Cash register cut type selection.
 * Renders a 3-column grid with two options: blind cut or visible cut.
 */
export const CashRegisterStep = () => {
  const { t } = useTranslation('onboarding');
  const { control } = useFormContext<WizardFormValues>();

  const options = useMemo(
    () => [
      {
        value: CASH_REGISTER_TYPES.BLIND,
        label: t('steps.cashRegister.options.blind'),
        description: t('steps.cashRegister.options.blindDescription'),
        icon: <EyeOff className="text-primary" size={24} />,
      },
      {
        value: CASH_REGISTER_TYPES.VISIBLE,
        label: t('steps.cashRegister.options.visible'),
        description: t('steps.cashRegister.options.visibleDescription'),
        icon: <Eye className="text-primary" size={24} />,
      },
    ],
    [t],
  );

  return (
    <StepLayout description={t('steps.cashRegister.description')} title={t('steps.cashRegister.title')}>
      <Controller
        control={control}
        name="cashRegister"
        render={({ field }) => (
          <RadioCardGrid columns={2} onChange={field.onChange} options={options} value={field.value} />
        )}
      />
    </StepLayout>
  );
};
